import { useRef, useState, useEffect } from "react";
import "../../assets/css/article/lazyImage.css";

export default function LazyImage({
  src,
  alt,
  className = "",
  defaultImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
}) {
  const imgRef = useRef();
  const [imageSrc, setImageSrc] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let observer;
    const element = imgRef.current;

    if (element) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setImageSrc(src);
            if (observer) observer.unobserve(element);
          }
        },
        {
          rootMargin: "100px",
          threshold: 0.01,
        }
      );
      observer.observe(element);
    }

    return () => {
      if (observer) observer.disconnect();
    };
  }, [src]);

  return (
    <div className={`lazy-wrapper ${className}`}>
      {(!loaded || !imageSrc) && (
        <div className="skeleton" aria-hidden="true" />
      )}

      <img
        ref={imgRef}
        src={imageSrc || defaultImage}
        alt={alt}
        itemProp="image"
        className={`lazy-image ${loaded ? "loaded" : "loading"}`}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setError(true);
          setImageSrc(defaultImage);
        }}
        style={{ opacity: loaded ? 1 : 0 }}
      />
    </div>
  );
}
